import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";

import * as jwt_decode from "jwt-decode";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class MyAuthService {
  public userInfo: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public userData = this.userInfo.asObservable();

  private readonly AUTH_TOKEN = "_token";
  private readonly REFRESH_TOKEN = "refresh_token";

  constructor(private router: Router, private _http: HttpClient) {}

  public login(data) {
    window.localStorage.setItem(this.AUTH_TOKEN, data.access_token);
    window.localStorage.setItem(this.REFRESH_TOKEN, data.refresh_token);
    this.getUserDetails();
    //console.log("obj", this.userInfo);
  }

  public logout() {
    window.localStorage.clear();
    this.getUserDetails();
  }

  public getUserDetails() {
    /* console.log(
      "window.localStorage.getItem(this.AUTH_TOKEN)",
      window.localStorage.getItem(this.AUTH_TOKEN)
    ); */
    if (window.localStorage.getItem(this.AUTH_TOKEN) !== null) {
      return this.userInfo.next(
        jwt_decode(window.localStorage.getItem(this.AUTH_TOKEN))
      );
    } else {
      return this.userInfo.next(null);
    }
  }

  public updateUserInfo(userInfo) {
    //console.log("UserInfo", userInfo, this.userInfo);
    this.userInfo.next(userInfo);
    //console.log("UserInfo", userInfo, this.userInfo);
  }

  public getAuthToken() {
    return window.localStorage.getItem(this.AUTH_TOKEN);
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  public logoutUser() {
    this.logout();
    return this.router.navigate(["/"]);
  }

  refreshToken(): Observable<any> {
    const token = this.getRefreshToken();
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token
    });

    return this._http
      .post("https://api.sma.infi.cf/auth/refresh", {}, { headers: headers })
      .pipe(
        map((result: any) => {
          if (result && result.access_token) {
            localStorage.setItem(this.AUTH_TOKEN, result.access_token);
            this.getUserDetails();
          }
          return result;
        })
      );
  }
}
